import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Statistic, Spin, message } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { statsAPI } from '../services/api';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await statsAPI.getOverview();
      setStats(response.data);
    } catch (error) {
      message.error('获取统计数据失败');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Spin size="large" />;
  }

  if (!stats) {
    return <div>暂无数据</div>;
  }

  return (
    <div>
      <h2>系统概览</h2>

      {/* 关键指标 */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic
              title="总请求数"
              value={stats.total_requests}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="分发成功"
              value={stats.total_delivered}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="分发率"
              value={stats.delivery_rate}
              precision={2}
              suffix="%"
              valueStyle={{ color: stats.delivery_rate > 50 ? '#3f8600' : '#cf1322' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="唯一访客"
              value={stats.unique_ips}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
      </Row>

      {/* 热门域名 */}
      <Row gutter={16}>
        <Col span={12}>
          <Card title="热门域名" style={{ marginBottom: 16 }}>
            {stats.top_domains.slice(0, 5).map((domain, index) => (
              <div key={index} style={{ marginBottom: 8 }}>
                <span>{domain.domain}</span>
                <span style={{ float: 'right' }}>
                  {domain.requests} 请求 ({domain.delivery_rate.toFixed(1)}%)
                </span>
              </div>
            ))}
          </Card>
        </Col>

        <Col span={12}>
          <Card title="热门脚本" style={{ marginBottom: 16 }}>
            {stats.top_scripts.slice(0, 5).map((script, index) => (
              <div key={index} style={{ marginBottom: 8 }}>
                <span>{script.script_name}</span>
                <span style={{ float: 'right' }}>
                  {script.requests} 次分发
                </span>
              </div>
            ))}
          </Card>
        </Col>
      </Row>

      {/* 扩展统计 */}
      <Row gutter={16}>
        <Col span={24}>
          <Card title="Web3钱包扩展统计">
            <Row gutter={16}>
              <Col span={4}>
                <Statistic title="MetaMask" value={stats.extensions_stats.metamask} />
              </Col>
              <Col span={4}>
                <Statistic title="TokenPocket" value={stats.extensions_stats.token_pocket} />
              </Col>
              <Col span={4}>
                <Statistic title="Trust Wallet" value={stats.extensions_stats.trust_wallet} />
              </Col>
              <Col span={4}>
                <Statistic title="Coinbase" value={stats.extensions_stats.coinbase_wallet} />
              </Col>
              <Col span={4}>
                <Statistic title="Phantom" value={stats.extensions_stats.phantom} />
              </Col>
              <Col span={4}>
                <Statistic title="总样本" value={stats.extensions_stats.total_samples} />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
